export default "__VITE_ASSET__58eeb03d__"